
export default function getTheme(state) {
  if (state.fontSizeOverride) {
    return {
      ...state.theme,
      fontSize_base: state.fontSizeOverride,
    };
  }

  return state.theme;
}

export function getThemeWithoutOverrides(state) {
  return state.theme;
}
